import "./InternalAdmin.scss";
import Header from "../Header";
import SubMenu from "./SubMenu";
import Content from "./Content";
import { useState } from "react";
import useLoader from "../../utils/useLoader";
import LoadingOverlayWrapper from "react-loading-overlay-ts";

function InternalAdmin() {
  const subMenus = ["Invite User"];
  const [selectedSubMenu, setSelectedSubMenu] = useState("Invite User");
  const { isPageLoading, setIsPageLoading } = useLoader();

  return (
    <LoadingOverlayWrapper active={isPageLoading} spinner>
      <div className="container">
        <Header />
        <div className="internal-admin-container">
          <div className="internal-admin-submenu">
            <SubMenu
              subMenus={subMenus}
              selectedSubMenu={selectedSubMenu}
              setSelectedSubMenu={setSelectedSubMenu}
            />
          </div>
          <div className="internal-admin-content">
            <Content selectedSubMenu={selectedSubMenu} setIsPageLoading={setIsPageLoading} />
          </div>
        </div>
      </div>
    </LoadingOverlayWrapper>
  );
}

export default InternalAdmin;
